'use client';
import { type PropsWithChildren } from 'react';

import ContentCopyRounded from '@mui/icons-material/ContentCopyRounded';
import { enqueueSnackbar } from 'notistack';

import { t } from '@/utils/lang';
import IconButton from '@mui/material/IconButton';

import Tooltip from '@mui/material/Tooltip';

interface CopyTextAction extends PropsWithChildren {
    value?: string | number;
}

interface CopyTextActionProps extends PropsWithChildren {
    value?: string | number;
}

export default function CopyTextAction({ value }: CopyTextActionProps) {
    const text = String(value ?? '');

    const onCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();

        try {
            await navigator.clipboard.writeText(text);

            enqueueSnackbar(t('Đã sao chép'), {
                variant: 'success',
                autoHideDuration: 1000,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
            });
        } catch {}
    };

    return (
        <Tooltip title={t('Sao chép')}>
            <IconButton
                size='small'
                aria-label='Copy value'
                onClick={onCopy}
                onMouseDown={e => {
                    e.stopPropagation();
                    e.preventDefault();
                }}
                tabIndex={-1}
                data-stop-row-click
                sx={{
                    fontSize: '15px !important',
                }}
            >
                <ContentCopyRounded fontSize='inherit' />
            </IconButton>
        </Tooltip>
    );
}
